import React, { useContext } from "react";
import Can from "../can/Can";
import { AppContext } from "../../App";
import { masterBalance } from "../../rbac-consts";
import MasterBalancesContainer from "./master/MasterBalancesContainer";

const MasterBalancesWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={masterBalance.MASTER}
      yes={() => (
        <MasterBalancesContainer />
      )}
    />
  );
};

export default MasterBalancesWrapper;